/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as AuthedImport } from './routes/_authed';
import { Route as IndexImport } from './routes/index';
import { Route as LoginIndexImport } from './routes/login/index';
import { Route as AuthedSettingIndexImport } from './routes/_authed/setting/index';
import { Route as AuthedProfileIndexImport } from './routes/_authed/profile/index';
import { Route as AuthedOfflineIndexImport } from './routes/_authed/offline/index';
import { Route as ProfilePublicUserSlugImport } from './routes/profile/public.$userSlug';
import { Route as AssetsIdentityIdentityIdImport } from './routes/assets/identity.$identityId';
import { Route as AssetsAchievementAchievementIdImport } from './routes/assets/achievement.$achievementId';

// Create/Update Routes

const AuthedRoute = AuthedImport.update({
  id: '/_authed',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const LoginIndexRoute = LoginIndexImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any);

const AuthedSettingIndexRoute = AuthedSettingIndexImport.update({
  id: '/setting/',
  path: '/setting/',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedProfileIndexRoute = AuthedProfileIndexImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedOfflineIndexRoute = AuthedOfflineIndexImport.update({
  id: '/offline/',
  path: '/offline/',
  getParentRoute: () => AuthedRoute,
} as any);

const ProfilePublicUserSlugRoute = ProfilePublicUserSlugImport.update({
  id: '/profile/public/$userSlug',
  path: '/profile/public/$userSlug',
  getParentRoute: () => rootRoute,
} as any);

const AssetsIdentityIdentityIdRoute = AssetsIdentityIdentityIdImport.update({
  id: '/assets/identity/$identityId',
  path: '/assets/identity/$identityId',
  getParentRoute: () => rootRoute,
} as any);

const AssetsAchievementAchievementIdRoute =
  AssetsAchievementAchievementIdImport.update({
    id: '/assets/achievement/$achievementId',
    path: '/assets/achievement/$achievementId',
    getParentRoute: () => rootRoute,
  } as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/_authed': {
      id: '/_authed';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AuthedImport;
      parentRoute: typeof rootRoute;
    };
    '/login/': {
      id: '/login/';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/assets/achievement/$achievementId': {
      id: '/assets/achievement/$achievementId';
      path: '/assets/achievement/$achievementId';
      fullPath: '/assets/achievement/$achievementId';
      preLoaderRoute: typeof AssetsAchievementAchievementIdImport;
      parentRoute: typeof rootRoute;
    };
    '/assets/identity/$identityId': {
      id: '/assets/identity/$identityId';
      path: '/assets/identity/$identityId';
      fullPath: '/assets/identity/$identityId';
      preLoaderRoute: typeof AssetsIdentityIdentityIdImport;
      parentRoute: typeof rootRoute;
    };
    '/profile/public/$userSlug': {
      id: '/profile/public/$userSlug';
      path: '/profile/public/$userSlug';
      fullPath: '/profile/public/$userSlug';
      preLoaderRoute: typeof ProfilePublicUserSlugImport;
      parentRoute: typeof rootRoute;
    };
    '/_authed/offline/': {
      id: '/_authed/offline/';
      path: '/offline';
      fullPath: '/offline';
      preLoaderRoute: typeof AuthedOfflineIndexImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/profile/': {
      id: '/_authed/profile/';
      path: '/profile';
      fullPath: '/profile';
      preLoaderRoute: typeof AuthedProfileIndexImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/setting/': {
      id: '/_authed/setting/';
      path: '/setting';
      fullPath: '/setting';
      preLoaderRoute: typeof AuthedSettingIndexImport;
      parentRoute: typeof AuthedImport;
    };
  }
}

// Create and export the route tree

interface AuthedRouteChildren {
  AuthedOfflineIndexRoute: typeof AuthedOfflineIndexRoute;
  AuthedProfileIndexRoute: typeof AuthedProfileIndexRoute;
  AuthedSettingIndexRoute: typeof AuthedSettingIndexRoute;
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedOfflineIndexRoute: AuthedOfflineIndexRoute,
  AuthedProfileIndexRoute: AuthedProfileIndexRoute,
  AuthedSettingIndexRoute: AuthedSettingIndexRoute,
};

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '': typeof AuthedRouteWithChildren;
  '/login': typeof LoginIndexRoute;
  '/assets/achievement/$achievementId': typeof AssetsAchievementAchievementIdRoute;
  '/assets/identity/$identityId': typeof AssetsIdentityIdentityIdRoute;
  '/profile/public/$userSlug': typeof ProfilePublicUserSlugRoute;
  '/offline': typeof AuthedOfflineIndexRoute;
  '/profile': typeof AuthedProfileIndexRoute;
  '/setting': typeof AuthedSettingIndexRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '': typeof AuthedRouteWithChildren;
  '/login': typeof LoginIndexRoute;
  '/assets/achievement/$achievementId': typeof AssetsAchievementAchievementIdRoute;
  '/assets/identity/$identityId': typeof AssetsIdentityIdentityIdRoute;
  '/profile/public/$userSlug': typeof ProfilePublicUserSlugRoute;
  '/offline': typeof AuthedOfflineIndexRoute;
  '/profile': typeof AuthedProfileIndexRoute;
  '/setting': typeof AuthedSettingIndexRoute;
}

export interface FileRoutesById {
  '__root__': typeof rootRoute;
  '/': typeof IndexRoute;
  '/_authed': typeof AuthedRouteWithChildren;
  '/login/': typeof LoginIndexRoute;
  '/assets/achievement/$achievementId': typeof AssetsAchievementAchievementIdRoute;
  '/assets/identity/$identityId': typeof AssetsIdentityIdentityIdRoute;
  '/profile/public/$userSlug': typeof ProfilePublicUserSlugRoute;
  '/_authed/offline/': typeof AuthedOfflineIndexRoute;
  '/_authed/profile/': typeof AuthedProfileIndexRoute;
  '/_authed/setting/': typeof AuthedSettingIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/assets/achievement/$achievementId'
    | '/assets/identity/$identityId'
    | '/profile/public/$userSlug'
    | '/offline'
    | '/profile'
    | '/setting';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | ''
    | '/login'
    | '/assets/achievement/$achievementId'
    | '/assets/identity/$identityId'
    | '/profile/public/$userSlug'
    | '/offline'
    | '/profile'
    | '/setting';
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login/'
    | '/assets/achievement/$achievementId'
    | '/assets/identity/$identityId'
    | '/profile/public/$userSlug'
    | '/_authed/offline/'
    | '/_authed/profile/'
    | '/_authed/setting/';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthedRoute: typeof AuthedRouteWithChildren;
  LoginIndexRoute: typeof LoginIndexRoute;
  AssetsAchievementAchievementIdRoute: typeof AssetsAchievementAchievementIdRoute;
  AssetsIdentityIdentityIdRoute: typeof AssetsIdentityIdentityIdRoute;
  ProfilePublicUserSlugRoute: typeof ProfilePublicUserSlugRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginIndexRoute: LoginIndexRoute,
  AssetsAchievementAchievementIdRoute: AssetsAchievementAchievementIdRoute,
  AssetsIdentityIdentityIdRoute: AssetsIdentityIdentityIdRoute,
  ProfilePublicUserSlugRoute: ProfilePublicUserSlugRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authed",
        "/login/",
        "/assets/achievement/$achievementId",
        "/assets/identity/$identityId",
        "/profile/public/$userSlug"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authed": {
      "filePath": "_authed.tsx",
      "children": [
        "/_authed/offline/",
        "/_authed/profile/",
        "/_authed/setting/"
      ]
    },
    "/login/": {
      "filePath": "login/index.tsx"
    },
    "/assets/achievement/$achievementId": {
      "filePath": "assets/achievement.$achievementId.tsx"
    },
    "/assets/identity/$identityId": {
      "filePath": "assets/identity.$identityId.tsx"
    },
    "/profile/public/$userSlug": {
      "filePath": "profile/public.$userSlug.tsx"
    },
    "/_authed/offline/": {
      "filePath": "_authed/offline/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/profile/": {
      "filePath": "_authed/profile/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/setting/": {
      "filePath": "_authed/setting/index.tsx",
      "parent": "/_authed"
    }
  }
}
ROUTE_MANIFEST_END */
